import brokers from './brokers.reducer';

const reducer = {
  brokers,
};

export default reducer;
